import { RichDataModel } from "./rich-data.model";

export class SurveyHeader {
    id: number;
    hotel_id: number;
    hotel_name: string;
    question_groups: string[];  // string Array[] Resepsiyon Hizmetleri,Misafir İlişkileri,Genel Alanlar,..... seçtirmek için kullanacağımız alan.
    name: string;
    groups: SurveyGroup[];
    description: string;
    status: 'passive' | 'active';
    notify_type: 'all' | 'negative';
    sending_result_type: 'none' | 'all user' | 'selected mail';
    emails: string;
    positive_redirect_urls: string[];  // [Trip Adviser,Holiday Check, Top Hotels, Otel Puan, Booking, Google,Expedia,Zoover] json şekilnde urlleri yazacak.
    thanks_message_for_positive_reviews: string;
    thanks_message_for_negative_reviews: string;
    ask_note_after_survey: boolean; // Anket sonunda Misafire ayrıca belirtmek istediğiniz notlar var mı sorusunu soralım. Varsa bu cevabı SurveySummary tablosuna yazalım.
    created_at: Date;
    updated_at: Date;
    survey_lines: SurveyLine[];

    constructor(
        hotelData: RichDataModel,
        groups: string[],
        name: string,
        description: string,
        notifyType: 'all' | 'negative',
        sendingResultType: 'none' | 'all user' | 'selected mail',
        emails: string = '',
        positiveRedirectUrls: string[] = [],
        thanksMessageForPositiveReviews: string = '',
        thanksMessageForNegativeReviews: string = '',
        askNoteAfterSurvey: boolean = false,
        lines: SurveyLine[]
    ) {
        this.hotel_id = hotelData.id;
        this.hotel_name = hotelData.name;
        this.question_groups = groups;
        this.name = name;
        this.description = description;
        this.status = 'active';
        this.notify_type = notifyType;
        this.sending_result_type = sendingResultType;
        this.emails = emails;
        this.positive_redirect_urls = positiveRedirectUrls;
        this.thanks_message_for_positive_reviews = thanksMessageForPositiveReviews;
        this.thanks_message_for_negative_reviews = thanksMessageForNegativeReviews;
        this.ask_note_after_survey = askNoteAfterSurvey;
        this.survey_lines = lines;
        this.created_at = new Date();
        this.updated_at = new Date();
    }
}

export class SurveyLine {
    id: number;
    hotel_id: number;
    survey_header_id: number;
    question_group: string; // Genel Alanlar
    question: string;
    question_type: 'nps' | 'smile' | 'yesno' | 'star' | 'multiselect' | 'select' | 'text' | 'textarea';
    description: string;
    priority: number;
    created_at: Date;
    updated_at: Date;

    option_values: OptionValue;
    negative_option_values: OptionValue;
    positive_option_values: OptionValue;
    negative_response_question: string;
    positive_response_question: string;
    /**
     * 
     * @description Use this key for answers, this key doesn't come from API! 
     */
    answer: number;
    responseStatus: string;
    answer_response: string[];

    constructor(
        hotelId: number,
        group: string,
        question?: string,
        questionType?: 'nps' | 'smile' | 'yesno' | 'star' | 'multiselect' | 'select' | 'text' | 'textarea',
        description?: string,
        priority?: number,
        surveyHeaderId?: number
    ) {
        this.id = 0;
        this.survey_header_id = surveyHeaderId || 0;
        this.hotel_id = hotelId;
        this.question_group = group;
        this.question = question || '';
        this.question_type = questionType || 'nps';
        this.description = description || '';
        this.priority = priority || 0;
        this.created_at = new Date();
        this.updated_at = new Date();
        this.option_values = new OptionValue();
        this.positive_option_values = new OptionValue();
        this.negative_option_values = new OptionValue();
    }
}

export class OptionValue {
    is_multiple: boolean;
    options: string[];
    constructor(
    ) {
        this.is_multiple = false;
        this.options = [];
    }
}
export class SurveyGroup {
    group: string;
    survey_lines: SurveyLine[];
    constructor() {
        this.group = '';
        this.survey_lines = [];
    }
}

export class SurveyAnswer {
    id: number;
    hotel_id: number;
    survey_header_id: number;
    survey_line_id: number;
    question_group: string; // Genel Alanlar
    question: string;
    question_type: string;
    description: string;
    priority: number;
    profile_id: number;
    answer: string;
    answer_response: string[];
    answer_numeric: number; // Değerlendirme dışı notları -1 gönderelim.
    created_at: Date;
    read_at: Date;
    read_by: string;
    name: string;
    room_no: string;
    phone_no: string;
    email: string;

    constructor(
        line: SurveyLine,
        profileId: number,
        name: string,
        room_no: string,
        phone_no: string,
        email: string,
    ) {
        this.id = 0;
        this.survey_header_id = line.survey_header_id;
        this.hotel_id = line.hotel_id;
        this.survey_line_id = line.id;
        this.question_group = line.question_group;
        this.question = line.question;
        this.question_type = line.question_type;
        this.description = line.description;
        this.priority = line.priority;
        this.profile_id = profileId;
        this.created_at = new Date();
        this.read_at = new Date();
        this.read_by = '';
        this.name = name;
        this.room_no = room_no;
        this.phone_no = phone_no;
        this.email = email;

        this.answer_response = line.answer_response;
        this.answer_numeric = line.answer === undefined ? -1 : line.answer;
    }
}

export class SurveyResult {
    survey_answers: SurveyAnswer[];
    note: string;

    constructor() {
        this.survey_answers = [];
        this.note = '';
    }
}

export interface SurveySummary {
    id: number;
    hotel_id: number;
    hotel_name: string;
    profile_id: number;
    profile_name: string;
    survey_header_id: number;
    survey_header_name: string;
    survey_header: SurveyHeader;
    survey_header_description: string;
    survey_result: number;
    profile_note: string;
    assessing_user_id: number;
    assessing_user_name: string;
    user_note: string;
}


